// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation ReceivePurchaseOrderMutation(
    $input: ReceivePurchaseOrderInput!
  ) {
    receivePurchaseOrder(input: $input) {
      success
      message
      receipt {
        id
        receivedAt
        receivedBy {
          id
          firstName
          lastName
        }
        notes
        receiptLines {
          id
          item {
            id
            itemNumber
            name
          }
          quantityReceived
          lotNumber
        }
      }
      poStatus
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
